<template>
    <div class="introduction-box">
        <img class="logo-icon" :src="currentStore.page_config?.nav_logo" alt />
        <div class="introduction" v-html="content" v-if="content">
        </div>
    </div>
</template>
<script setup>

import { onMounted, ref } from 'vue'

const props = defineProps({
    currentStore: {
        type: Object
    }
})

const content = ref('')

onMounted(() => {
    const introduction = props.currentStore?.page_config?.introduction
    if (introduction) {
        content.value = introduction.split(/\r?\n/)
            .filter(line => line.trim())
            .map(line => `<p>${line}</p>`)
            .join('');
    }
})

</script>

<style lang="scss" scoped>
.introduction-box {
    text-align: center;
}

.logo-icon {
    width: 500px;
    margin: 0 auto;
    margin-bottom: 20px;
}

.introduction {
    max-width: 1340px;
    padding: 0 20px;
    margin: 0 auto;
    margin-top: 50px;
    margin-bottom: 150px;

    font-size: 16px;
    line-height: 2;
    text-align: justify;
    white-space: pre-line;

    :deep(p) {
        text-indent: 2em;

        &:not(:first-child) {
            margin-top: 1em;
        }
    }
}

#content {
    &.phone-mode {
        .introduction-box {
            margin-top: 20px;
        }

        .logo-icon {
            width: 80%;
            margin-bottom: 0;
        }

        .introduction {
            flex-direction: column;
            margin-top: 20px;
            margin-bottom: 50px;
        }
    }
}
</style>